var render = function render(_c,_vm){return (_vm.$options.DisplayValue(_vm.props))?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.Selected(_vm.props)}}},[_vm._v(_vm._s(_vm.$options.DisplayValue(_vm.props)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }